import Ui from './client-ui'

export default class Log
{
	static info(message, run = undefined)
	{
		this._take('info', message, run)
	}

	static debug(message, run = undefined)
	{
		this._take('debug', message, run)
	}

	static _take(type, message, run = undefined)
	{
		try
		{
			const stack = (new Error()).stack

			if(stack === undefined) console.log(message)
			else console[type](`${message} : ${stack.split(/\n/)[2].replace(/^\s*at /, '')}`)
		}
		catch(exception)
		{
			//Do not let exceptions get out of Log class
			console.error(`Error printing error stack : ${exception.stack}`)
		}

		try
		{
			if(typeof run === 'function')
			{
				const start = (new Date()).getTime()
				const result = run()

				const end = (new Date()).getTime()
				console[type](Math.ceil((end - start) / 10) / 100 + 's')

				return result
			}
		}
		catch(exception)
		{
			console.error(exception.message)
			console.error(exception.stack)

			Ui.error(exception.message)
		}
	}
}
